export default [
    {
        path: '/ship-out/manually',
        name: 'ship-out_manually',
        component: () => import('@src/ship-out/manual-shipment/index'),
        meta: {
            title: 'Handlabel',
            role: 'ROLE_CREATE_MANUAL_SHIPMENT',
        },
    },
    {
        path: '/ship-out/create',
        name: 'ship-out_create',
        component: () => import('@src/ship-out/create-shipment'),
        meta: {
            title: 'Versenden',
            role: 'ROLE_CREATE_SHIPMENT',
        },
    },
    {
        path: '/ship-out/list-shipments',
        name: 'ship-out_list-shipments',
        component: () => import('@src/ship-out/list-shipments'),
        meta: {
            title: 'Liste aller Sendungen',
            role: 'ROLE_LIST_SHIPMENT_DETAIL',
        },
    },
    {
        path: '/ship-out/detail/:type/:id',
        name: 'ship-out_shipment-detail',
        component: () => import('@src/ship-out/shipment-detail'),
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null, type: route.params.type };
        },
        meta: {
            title: 'Sendungsdetail',
            role: 'ROLE_SHOW_SHIPMENT_DETAIL',
        },
    },
    {
        path: '/ship-out/docs/:tab?',
        name: 'ship-out_docs',
        component: () => import('@src/ship-out/ship-out-docs.vue'),
        meta: {
            title: 'Hilfe',
            role: 'ROLE_SHIP_OUT_DOCS',
        },
    },
];
